var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-marker',{ref:"marker",attrs:{"lat-lng":_vm.latLng,"icon":_vm.icon}})}
var staticRenderFns = []

export { render, staticRenderFns }